
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"width":"19","height":"20","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.067 4H14a5 5 0 015 5v3a5 5 0 01-5 5h-1.166v-2H14a3 3 0 003-3V9a3 3 0 00-3-3H5.067v4L0 5l5.067-5v4z"}}),_c('text',{attrs:{"font-family":"HelveticaNeue-Bold, Helvetica Neue","font-size":"10","font-weight":"bold","letter-spacing":".125"}},[_c('tspan',{attrs:{"x":"0","y":"19"}},[_vm._v("15")])])])
      }
    
      }
    